<template>
  <div id="app">
    <div class="headerContainer">
      <div class="container">
        <Navbar />
      </div>
    </div>
    <br />

    <div class="main-container" v-if="!verifyingToken">
      <SimpleForm />
    </div>

    <div class="main-container" v-if="verifyingToken">
      <div class="text-center" v-if="loading">
        <div class="spinner-border" role="status">
          <span class="sr-only">Cargando...</span>
        </div>
      </div>

      <div class="container" v-if="showModal">
        <div class="card-content">
          <div class="content">
            <h1 class="is-5 centered">
              {{ alert.title }}
            </h1>
            <p class="detail centered">
              {{ alert.detail }}
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Navbar from "./components/Navbar.vue";
import SimpleForm from "./components/SimpleForm.vue";

// import axios from 'axios';

export default {
  name: "app",
  components: {
    Navbar,
    SimpleForm,
  },
  mounted() {
    const token = this.$route.query.token;
    if (!token) {
      this.verifyingToken = false;
    } else {
      this.verifyingToken = true;
      // this.validateToken(token)
    }
  },
  data() {
    return {
      verifyingToken: true,
      loading: true,
      showModal: false,
      alert: {
        title: "",
        detail: "",
      },
    };
  },
  methods: {
    /* validateToken(token) {
      this.loading = true;
      axios.get(`${process.env.VUE_APP_SERVER_ENDPOINT}/invoice/validate/${token}`)
        .then(() => {
          this.alert = {
            title: 'Correo validado exitosamente',
            detail: 'El correo ha sido validado exitosamente',
          }
          this.showModal = true;
        })
        .catch(err => {
          const code = err.response.status
          if (code === 403) {
            this.alert = {
              title: 'Correo ya ha sido validado',
              detail: 'El correo ya ha sido validado'
            }
          } else {
            this.alert = {
              title: 'Ha ocurrido un error',
              detail: err.response.data
            }
          }
          this.showModal = true;
        }).finally(() => {
          this.loading = false;
        })
        },*/
  },
};
</script>

<style scoped>
.hr {
  background-color: #e6ce9e;
  margin: 0;
  height: 5px;
}
.centered {
  margin-top: 20px;
  text-align: center;
}
.headerContainer {
  background: #16233b !important;
}
</style>
